<template>
    <div>
        <div class="modal fade" id="verifynumber" tabindex="-1" aria-labelledby="verifynumberLabel" aria-hidden="true"
            data-bs-backdrop="false" style="background-color:rgba(0, 0, 0, 0.5);">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content" :style="skin.my_account.main_background">
                    <div class="modal-header p-0" style="border-bottom: none;">
                        <h5 class="modal-title" id="exampleModalLabel"></h5>
                        <button :style="skin.my_account.close_btn" style="background:transparent;"
                            type="button" class="btn-close m-1" data-bs-dismiss="modal" aria-label="Close" id="cerrarcodigo"><i
                                class="fas fa-times"></i></button>
                    </div>
                    <div class="modal-body p-4" style="height:30%" >
                        <div class="text-center">
                            <span>Ingresa el numero que te llego al telefono</span><br>
                            <form @submit.prevent="verifyNumber()">
                                <div class="mb-3" v-if="!this.$props.datos">
                                    <label for="registerCurrency">{{ translate('phone') }}</label>&nbsp;&nbsp;
                                    <div class="d-flex">
                                        <div class="input-group me-1" style="width:40%">
                                            <span class="input-group-text" id="basic-addon1">+</span>
                                            <input type="number" v-model="phone_code" class="form-control"
                                                :placeholder="translate('country_code')"
                                                :disabled="skin.register_fields.default_phone_code != 0">
                                        </div>
                                        <div style="width:60%;">
                                            <input v-model="phone" type="number" class="form-control"
                                                :placeholder="translate('enter_number')">
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <label for="registerCurrency">{{ translate('Codigo') }}</label>&nbsp;&nbsp;
                                    <div class="d-flex">
                                        <div class="input-group me-1">
                                            <input type="number" v-model="code" class="form-control"
                                                :placeholder="translate('Escribe el codigo')">
                                        </div>
            
                                    </div>
                                </div>
                                <button id="submit_btn4" type="submit" :style="skin.qbet.booking_btn"
                                    class="p-2 text-center mb-2"
                                    style="width:100%;color:white">{{ translate("Enviar") }}</button>
                            </form>
                            <div v-if="status.message != ''" :class="'alert alert-' + status.type" role="alert">{{
                                status.message }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <button data-bs-target="#registerModalToggle5" data-bs-toggle="modal"
                                data-bs-dismiss="modal" style="display:none;" id="registerSuccessfull1"></button>
         <div class="modal fade" id="registerModalToggle5" aria-hidden="true" aria-labelledby="registerModalToggle5Label"
            tabindex="-1" data-bs-backdrop="false" style="background-color:rgba(0, 0, 0, 0.5);">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content" :style="skin.my_account.main_background">
                    <div class="modal-header" style="border-bottom: none;">
                        <button :style="skin.my_account.close_btn" style="background: none;" type="button"
                            class="btn-close" data-bs-dismiss="modal" aria-label="Close"><i
                                class="fas fa-times"></i></button>
                    </div>
                    <div class="modal-body">
                        <div class="text-center p-2">
                            <span style="font-size:64px;color:green;"><i class="fas fa-check-circle"></i></span><br>
                            <span>{{ translate('register_success') }}</span><br>
                            <span>{{ translate('can_login') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name: "login",
    props: ['skin', 'language','translation', 'datos'],
    data() {
        return {
            phone: "",
            phone_code: "",
            code: "",
            resetPassword: false,
            status: {
                message: "",
                type: ""
            },
            login_inProcess: false
        }
    },
    computed: {
    },
    methods: {
        async verifyNumber() {
            // if (!this.phone_code || !this.phone ) {
            //     this.status.message = "Llena los datos";
            //     this.status.type = "danger";
            //     return;
            // }

            try {
                let domain = this.$store.getters["getApiUrlnew"];
                let phone =this.datos.phone_code +this.datos.phone || this.phone_code + this.phone ;
                const response = await axios.post(`${domain}verify_phone`, {
                    phone: '+' + phone,
                    token: "qCpxTbvkZBePznR",
                    code: this.code
                });
                if (response.data.code !== 200) {
                    this.status.message = "Numero no encontrado/ o no registrado";
                    this.status.type = "danger";
                }
                else if(response.data.code === 200) {
                    this.status.message = "Código enviado correctamente";
                    document.getElementById('cerrarcodigo').click()
                    document.getElementById('registerSuccessfull1').click()
                    this.status.type = "success";
                    
                }

            } catch (err) {
                this.status.message = "No se pudo enviar el código. Intenta nuevamente.";
                this.status.type = "danger";
                console.error(err);
            }
        },
        translate(text) {
            if (text) {
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else {
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        },
    }
}
</script>

<style></style>